"use strict";
exports.__esModule = true;
exports.OpenViduLogger = void 0;
var jsnlog_1 = require("jsnlog");
var OpenViduLoggerConfiguration_1 = require("./OpenViduLoggerConfiguration");
var OpenViduLogger = /** @class */ (function () {
    function OpenViduLogger() {
        this.JSNLOG_URL = "/openvidu/elk/openvidu-browser-logs";
        this.MAX_JSNLOG_BATCH_LOG_MESSAGES = 100;
        this.MAX_MSECONDS_BATCH_MESSAGES = 5000;
        this.MAX_LENGTH_STRING_JSON = 1000;
        this.logger = window.console;
        this.LOG_FNS = [this.logger.log, this.logger.debug, this.logger.info, this.logger.warn, this.logger.error];
        this.isProdMode = false;
        this.isJSNLogSetup = false;
    }
    OpenViduLogger.configureJSNLog = function (openVidu, token) {
        var _this = this;
        try {
            // If instance is created and it is OpenVidu Pro
            if (this.instance && openVidu.webrtcStatsInterval > -1
                // If logs are enabled
                && openVidu.sendBrowserLogs === OpenViduLoggerConfiguration_1.OpenViduLoggerConfiguration.debug
                // Only reconfigure it if session or finalUserId has changed
                && this.instance.canConfigureJSNLog(openVidu, this.instance)) {
                // isJSNLogSetup will not be true until completed setup
                this.instance.isJSNLogSetup = false;
                this.instance.info("Configuring JSNLogs.");
                var finalUserId_1 = openVidu.finalUserId;
                var sessionId_1 = openVidu.session.sessionId;
                var beforeSendCallback = function (xhr) {
                    // If 401 or 403 or 404 modify ready and status so JSNLog don't retry to send logs
                    // https://github.com/mperdeck/jsnlog.js/blob/v2.30.0/jsnlog.ts#L805-L818
                    var parentReadyStateFunction = xhr.onreadystatechange;
                    xhr.onreadystatechange = function () {
                        if ((xhr.status == 401) || (xhr.status == 403) || (xhr.status == 404)) {
                            Object.defineProperty(xhr, "readyState", { value: 4 });
                            Object.defineProperty(xhr, "status", { value: 200 });
                        }
                        parentReadyStateFunction();
                    };
                    // Headers to identify and authenticate logs
                    xhr.setRequestHeader('Authorization', "Basic " + btoa(finalUserId_1 + "%/%" + sessionId_1 + ":" + token));
                    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                    // Additional headers for OpenVidu
                    xhr.setRequestHeader('OV-Final-User-Id', finalUserId_1);
                    xhr.setRequestHeader('OV-Session-Id', sessionId_1);
                    xhr.setRequestHeader('OV-Token', token);
                };
                // Creation of the appender.
                this.instance.currentAppender = jsnlog_1.JL.createAjaxAppender("appender-" + finalUserId_1 + "-" + sessionId_1);
                this.instance.currentAppender.setOptions({
                    beforeSend: beforeSendCallback,
                    maxBatchSize: 1000,
                    batchSize: this.instance.MAX_JSNLOG_BATCH_LOG_MESSAGES,
                    batchTimeout: this.instance.MAX_MSECONDS_BATCH_MESSAGES
                });
                // Avoid circular dependencies
                var logSerializer = function (obj) {
                    var getCircularReplacer = function () {
                        var seen = new WeakSet();
                        return function (key, value) {
                            if (typeof value === "object" && value != null) {
                                if (seen.has(value) || value instanceof HTMLElement) {
                                    return;
                                }
                                seen.add(value);
                            }
                            return value;
                        };
                    };
                    // Cut long messages
                    var stringifyJson = JSON.stringify(obj, getCircularReplacer());
                    if (stringifyJson.length > _this.instance.MAX_LENGTH_STRING_JSON) {
                        return stringifyJson.substring(0, _this.instance.MAX_LENGTH_STRING_JSON) + "...";
                    }
                    return stringifyJson;
                };
                // Initialize JL to send logs
                jsnlog_1.JL.setOptions({
                    defaultAjaxUrl: openVidu.httpUri + this.instance.JSNLOG_URL,
                    serialize: logSerializer
                });
                jsnlog_1.JL().setOptions({
                    appenders: [this.instance.currentAppender]
                });
                this.instance.isJSNLogSetup = true;
                this.instance.loggingSessionId = sessionId_1;
                this.instance.loggingFinalUserId = finalUserId_1;
                this.instance.info("JSNLog configured.");
            }
        }
        catch (e) {
            console.error("Error configuring JSNLog: ");
            console.error(e);
            this.instance.isJSNLogSetup = false;
            this.instance.loggingSessionId = undefined;
            this.instance.loggingFinalUserId = undefined;
            this.instance.currentAppender = undefined;
        }
    };
    OpenViduLogger.getInstance = function () {
        if (!OpenViduLogger.instance) {
            OpenViduLogger.instance = new OpenViduLogger();
        }
        return OpenViduLogger.instance;
    };
    OpenViduLogger.prototype.isDebugLogEnabled = function () {
        return this.isJSNLogSetup;
    };
    OpenViduLogger.prototype.canConfigureJSNLog = function (openVidu, logger) {
        return openVidu.session.sessionId != logger.loggingSessionId;
    };
    OpenViduLogger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.isProdMode) {
            this.LOG_FNS[0].apply(this.logger, arguments);
        }
        if (this.isDebugLogEnabled()) {
            jsnlog_1.JL().info(arguments);
        }
    };
    OpenViduLogger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.isProdMode) {
            this.LOG_FNS[1].apply(this.logger, arguments);
        }
    };
    OpenViduLogger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.isProdMode) {
            this.LOG_FNS[2].apply(this.logger, arguments);
        }
        if (this.isDebugLogEnabled()) {
            jsnlog_1.JL().info(arguments);
        }
    };
    OpenViduLogger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.isProdMode) {
            this.LOG_FNS[3].apply(this.logger, arguments);
        }
        if (this.isDebugLogEnabled()) {
            jsnlog_1.JL().warn(arguments);
        }
    };
    OpenViduLogger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.LOG_FNS[4].apply(this.logger, arguments);
        if (this.isDebugLogEnabled()) {
            jsnlog_1.JL().error(arguments);
        }
    };
    OpenViduLogger.prototype.flush = function () {
        if (this.isDebugLogEnabled() && this.currentAppender != null) {
            this.currentAppender.sendBatch();
        }
    };
    OpenViduLogger.prototype.enableProdMode = function () {
        this.isProdMode = true;
    };
    return OpenViduLogger;
}());
exports.OpenViduLogger = OpenViduLogger;
//# sourceMappingURL=OpenViduLogger.js.map